import { compose } from '../../../../src/web/utils/react';
import { widget } from '../../../../src/web/components/widgets/decorators';
import { NAME, ID } from './properties';
import DirectionsText from './DirectionsText';

export default compose(
  widget(
    { name: NAME, deprecated: true, componentId: ID },
    {
      defaults: {
        rawContentState: {
          blocks: [
            {
              key: 'dl71j',
              text: 'From Downtown Kansas City, KS (North):',
              type: 'unstyled',
              depth: 0,
              inlineStyleRanges: [
                {
                  offset: 0,
                  length: 38,
                  style: 'BOLD',
                },
              ],
              entityRanges: [],
              data: {},
            },
            {
              key: 'vk5n',
              text: 'Take I-635 S.',
              type: 'unordered-list-item',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            },
            {
              key: '8qbuo',
              text: 'Appreciate the beauty of nature',
              type: 'unordered-list-item',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            },
            {
              key: '2q56e',
              text: 'Take exit toward Merriam Dr.',
              type: 'unordered-list-item',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            },
            {
              key: '100l4',
              text: 'Turn left onto Merriam Dr.',
              type: 'unordered-list-item',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            },
            {
              key: '12hdd',
              text: 'Continue onto Merriam Ln.',
              type: 'unordered-list-item',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            },
            {
              key: 'fohu7',
              text: 'Shamrock Self Storage is on the left ',
              type: 'unordered-list-item',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            },
            {
              key: 'adn2i',
              text: 'From Downtown Kansas City, MO (East):',
              type: 'unstyled',
              depth: 0,
              inlineStyleRanges: [
                {
                  offset: 0,
                  length: 37,
                  style: 'BOLD',
                },
              ],
              entityRanges: [],
              data: {},
            },
            {
              key: '6e1pv',
              text: 'Slight left onto I-670 W.',
              type: 'unordered-list-item',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            },
            {
              key: 'dfltv',
              text: 'Take exit 2T for I-35 S. toward Wichita ',
              type: 'unordered-list-item',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            },
            {
              key: '9g5v0',
              text: 'Park your vehicle ',
              type: 'unordered-list-item',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            },
            {
              key: '3pj47',
              text: 'Get blanket and picnic basket out of your trunk',
              type: 'unordered-list-item',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            },
            {
              key: 'ebce6',
              text: 'Walk 750 feet toward the grassy knoll',
              type: 'unordered-list-item',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            },
            {
              key: 'e3kht',
              text: 'Enjoy lunch',
              type: 'unordered-list-item',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            },
            {
              key: '3erjt',
              text: 'Get back into vehicle',
              type: 'unordered-list-item',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            },
            {
              key: 'dp2k3',
              text: 'Drive another few miles',
              type: 'unordered-list-item',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            },
          ],
          entityMap: {},
        },
      },
    },
  ),
)(DirectionsText);
